import React from 'react'
import ContentWrapper from '../components/contentwrapper/ContentWrapper'
import { Helmet } from 'react-helmet'
import DashboardSection from '../components/dashboard/DashboardSection'
import withAuth from '../utils/withAuth'
import UpcomingBirthday from '../components/dashboard/UpcomingBirthday'
import HolidayEvent from '../components/dashboard/HolidayEvent'
import LeaveReport from '../components/dashboard/LeaveReport'
import TodayLeave from '../components/dashboard/TodayLeave'
import Annoucement from '../components/dashboard/Annoucement'
import TodayBirthday from '../components/dashboard/TodayBirthday'

const Dashboard = () => {
    
    return (
        <div className="hrDashboard">
            <Helmet>
                <title>SATKARTAR:HR::DASHBOARD</title>
            </Helmet>
            <ContentWrapper>
                <div>
                    <DashboardSection />
                </div>
                {/* <div className="row">
                    <div className="col-12 col-lg-6 col-xl-4 d-flex birthdaysection">
                        <TodayBirthday />
                    </div>
                    <div className="col-12 col-lg-6 col-xl-4 d-flex birthdaysection">
                        <UpcomingBirthday />
                    </div>
                    <div className="col-12 col-lg-6 col-xl-4 d-flex birthdaysection">
                        <HolidayEvent />
                    </div>
                </div>
                <div className="row leavesections">
                    <div className="col-12 col-lg-6 col-xl-8 d-flex leavesection">
                        < LeaveReport />
                    </div>
                    <div className="col-12 col-lg-6 col-xl-4 leavesections">
                        <TodayLeave />
                        <Annoucement />
                    </div>
                </div> */}
            </ContentWrapper>
        </div>
    )
}

export default withAuth(Dashboard)
